// extracted by mini-css-extract-plugin
export default {"fieldset":"lNjYfJNSJzD2tI9xiWOS"};